import React from 'react';
import PropTypes from 'prop-types';
import { HeadHelmet } from 'components/head-helmet/head-helmet';
import { Sportsbook } from 'components/sportsbook/sportsbook';

import { PAGE_NAMES } from '../../constants';

const InPlayPage = ({ route: { page } }) => (
  <>
    <HeadHelmet page={PAGE_NAMES.IN_PLAY} />

    <Sportsbook currentPage={page} isLive />
  </>
);

InPlayPage.propTypes = {
  route: PropTypes.shape().isRequired,
};

export default InPlayPage;
